import API from "../app/api";

export const getReason = async (returnType) => {
    const res = await API.get(`/reasons/${returnType}`);
    return res || [];
};